import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";

import { LocalizationProvider } from "@progress/kendo-react-intl";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import InputTextArea from "./kendo/inputTextArea";
import Input from "./kendo/input";
import ValidationPresta from "./detailPresta/validationPresta";
import { sendAllData } from "../functions/sendAllPresta";


interface ValidationFormProps {
  source: "datas" | "details";
  datas?: any[];
  pvId: null | number;
  devId: null | number;
  details?: any[];
  presta: any;
  conf: any;
  selectedDate: Date;
  changeDate: (value: any) => void;
  handleSubmit: (e: React.FormEvent) => void;
  updateFn: (rplId: string, key: string, value: any) => void;
  onValidate: (
    rplId: string,
    key: string,
    showError: any,
    showModal: any,
    setDetails: any,
    conf: any,
    ...extra: any[]
  ) => void;
  showError: any;
  showModal: any;
  setDetails: any;
  extraParams?: any[];
  entete: any;
  mode?: "standard" | "phase" | "offline"; // <-- nouveau
}

const ValidationForm: React.FC<ValidationFormProps> = ({
  source,
  datas,
  pvId,
  devId,
  details,
  presta,
  conf,
  selectedDate,
  changeDate,
  handleSubmit,
  updateFn,
  onValidate,
  showError,
  showModal,
  setDetails,
  extraParams = [],
  entete,
  mode = "standard",
}) => {

  const item =
    source === "datas"
      ? Array.isArray(datas)
        ? datas[0]
        : datas
      : Array.isArray(details)
        ? details[0]
        : details;
  if (!item) return null;

  return (
    <div key={item.rpl_id}>
      <form onSubmit={handleSubmit}>
        {/* Commentaire */}
        <div className="descriptionValid">
          <span className="titleCategory">Commentaire :</span>
          <InputTextArea
            name=""
            onChange={(e) => updateFn(item.rpl_id, "e_observation_html", e)}
            value={
              item.informationSign?.e_observation_html === ""
                ? null
                : item?.informationSign?.e_observation_html
            }
            readOnly={item.isValid}
          />
        </div>

        {/* Localisation + Date */}
        <div className="localisationValid">
          <div className="dateValid">
            <span className="titleCategory">A :</span>
            <Input
              readOnly={item.isValid}
              name=""
              onChange={(e) => updateFn(item.rpl_id, "e_lieu_signature", e)}
              value={item?.informationSign?.e_lieu_signature}
            />
          </div>
          <div className="dateValid">
            <span className="titleCategory">Le :</span>
            <div className="datepickerValid">
              <LocalizationProvider language="fr-FR">
                <IntlProvider locale="fr">
                  <DatePicker
                    className="customPicker"
                    format={"dd/MM/yyyy"}
                    defaultValue={selectedDate}
                    onChange={(e: any) => changeDate(e.target.value)}
                  />
                </IntlProvider>
              </LocalizationProvider>
            </div>
          </div>
        </div>

        {/* Signatures */}
        <div className="containerValidationPresta">
          {/* Responsable */}
          <div className="containerNameSignature">
            <div className="sectionName">
              <p className="titleCategory">
                <FormattedMessage
                  id="nomResponsable"
                  defaultMessage="Nom du Responsable"
                />
              </p>
              <div className="namePresta">
                <Input
                  name=""
                  onChange={(e) =>
                    updateFn(item.rpl_id, "e_nom_responsable", e)
                  }
                  value={
                    item?.informationSign?.e_nom_responsable ||
                    presta?.e_nom_responsable ||
                    ""
                  }
                  readOnly={item.isValid}
                />
              </div>
            </div>
            <ValidationPresta
              signature={item?.informationSign?.e_signature_responsable}
              onUpdate={(key: string, value: string) =>
                updateFn(item.rpl_id, key, value)
              }
              inputKey="e_signature_responsable"
              readOnly={item.isValid}
            />
          </div>

          {/* Client */}
          <div className="containerNameSignature">
            <div className="sectionName">
              <p className="titleCategory">
                <FormattedMessage id="nomClient" defaultMessage="Nom du Client" />
              </p>
              <div className="namePresta">
                <Input
                  name=""
                  onChange={(e) =>
                    updateFn(item.rpl_id, "e_nom_client", e)
                  }
                  value={
                    // (() => {
                    //   const currentValue = item?.informationSign?.e_nom_client;
                    //   if (currentValue !== "") {
                    //     return currentValue;
                    //   }
                    //   const initialValue = presta?.v_cli_civ_nom;
                    //   // auto‑update si vide
                    //   updateFn(item.rpl_id, "e_nom_client", initialValue);
                    //   return initialValue;
                    // })()
                    item?.informationSign?.e_nom_client ||
                    ""}
                  readOnly={item.isValid}
                />
              </div>
            </div>
            <ValidationPresta
              signature={item?.informationSign?.e_signature_client}
              onUpdate={(key: string, value: string) =>
                updateFn(item.rpl_id, key, value)
              }
              inputKey="e_signature_client"
              readOnly={item.isValid}
            />
          </div>
        </div>

        {/* Bouton */}
        {!item.isValid && !item.isSent ? (
          <button
            type="submit"
            onClick={() =>
              onValidate(
                item?.rpl_id,
                "isValid",
                showError,
                showModal,
                setDetails,
                conf,
                ...extraParams
              )
            }
            className="validButtonForms"
          >
            Valider
          </button>
        ) : (item
          ? details?.[0] && !details[0].isSent
          : item.isValid && item.isSent !== false && undefined
        ) ? (
          <button
            type="submit"
            onClick={() => {
              sendAllData(details, pvId, devId, conf, showError, showModal, setDetails)
            }}
            className="validButtonForms"
          >
            Envoyer
          </button>
        ) : null}

      </form>
    </div>
  );
};
export default ValidationForm;
